import React, { Component } from 'react';
 
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from 'react-accessible-accordion';

import './Terms.css';
import 'react-accessible-accordion/dist/minimal-example.css';

class Terms extends Component {

  componentWillMount = () => {
    document.title = 'Algemene voorwaarden';
  }

  render() {
    return(
        <div className='terms'>
          <h1>Algemene voorwaarden voor de Onlinediensten van McDonald’s (Nederland)</h1>
          <p><em>Laatst bijgewerkte versie d.d.: 15 mei 2025,</em></p>
          <p><strong><span className='underlined'>BELANGRIJK:</span> LEES DEZE ALGEMENE VOORWAARDEN (“VOORWAARDEN”) ZORGVULDIG DOOR EN ZORG DAT JE ZE BEGRIJPT. ZIJ BEVATTEN AANSPRAKELIJKHEIDSBEPERKINGEN VAN MCDONALD’S EN ANDERE BEPALINGEN DIE VAN INVLOED ZIJN OP JOUW WETTELIJKE RECHTEN. </strong></p>
          <p>Door het installeren, bezoeken of gebruiken van websites, mobiele apps, nieuwsbrieven per e-mail, abonnementen en andere digitale toepassingen waarop deze voorwaarden worden geplaatst of die naar deze voorwaarden verwijzen (tezamen de “onlinediensten”), ga je een bindende overeenkomst aan met McDonald’s Nederland B.V. en met McDonald’s Marketing Coöperatie (“McDonald’s”, “wij” of “ons”). McDonald’s is in Nederland actief vanuit haar hoofdkantoor aan het Stadsplateau 31-32 in (3521 AZ) Utrecht.</p>
          <p>Je dient daarnaast onze Privacyverklaring te lezen, waarin wordt beschreven hoe wij informatie verzamelen, gebruiken en delen.  </p>
          <p>De onlinediensten zijn niet bedoeld voor personen onder de 16 jaar, en zijn daar ook niet op gericht. Je moet ten minste 16 jaar zijn als je gebruik wilt maken van de onlinediensten.  Als je wel 16 bent, maar nog geen 18 (of nog niet meerderjarig bent, als de wettelijke meerderjarigheid in jouw jurisdictie op een andere leeftijd intreedt), dien je deze voorwaarden met een van je ouders of je voogd te lezen en dienen zij deze voorwaarden te begrijpen en ermee akkoord te gaan voordat je gebruik mag maken van de onlinediensten. </p>
          <p>Als jij of je ouder of voogd niet akkoord gaat met deze voorwaarden, dien je het gebruik van de onlinediensten onmiddellijk te staken en McDonald’s te vragen het account dat je voor de onlinediensten hebt aangemaakt te sluiten. Je kunt om verwijdering van je account verzoeken door een e-mail te sturen naar gastenrelaties@nl.mcd.com en daarin het e-mailadres te vermelden van het account die verwijderd moet worden. </p>
          <p>Als McDonald’s op enig moment constateert dat een gebruiker van de onlinediensten jonger dan 16 jaar is of dat de gebruiker ouder dan 16 jaar maar jonger dan 18 jaar oud is en de ouder of voogd verklaren geen toestemming te hebben verleend, dan zal McDonald’s overgaan tot verwijdering van het account. </p>
          <Accordion>
            <AccordionItem>
              <AccordionItemTitle>
                <h2>1. Over de onlinediensten</h2>
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="extendable_content">
                  <p>
                    <strong>Beschikbaarheid van producten en diensten.</strong> De producten en diensten van McDonald's zijn op
                    veel plaatsen in de wereld beschikbaar, maar de onlinediensten kunnen ook producten en
                    diensten vermelden die niet wereldwijd beschikbaar zijn.
                  </p>
                  <p>
                    <strong>Veilig in het verkeer.</strong> Altijd wanneer je gebruikmaakt van de onlinediensten, dien je de
                    verkeersregels en alle toepasselijke regelgeving in acht te nemen. GEBRUIK DE
                    ONLINEDIENSTEN NIET TERWIJL JE EEN VOERTUIG BESTUURT OF ACHTER HET STUUR OF HET
                    BEDIENINGSPANEEL ZIT VAN EEN VOERTUIG DAT IN BEWEGING IS OF NIET OP DE HANDREM
                    STAAT”. Met het oog op de veiligheid van jou en anderen mag je de onlinediensten uitsluitend
                    gebruiken wanneer dat veilig is en wettelijk is toegestaan.
                  </p>
                  <p>
                    <strong>Verantwoordelijkheid voor je apparatuur en accounts.</strong> Je bent verantwoordelijk voor alle
                    apparatuur, software en diensten die nodig zijn om gebruik te maken van de onlinediensten.
                    McDonald’s geeft geen garantie dat de onlinediensten volledig functioneren op bepaalde
                    apparatuur of met bepaalde software. Je bent daarnaast verantwoordelijk voor het versturen
                    van berichten en je datagebruik, kosten en eventuele belasting voor je gebruik van de
                    onlinediensten, ook wanneer wij per sms, e-mail of op een andere door jou te bepalen wijze
                    met je communiceren. Je mag de onlinediensten uitsluitend gebruiken met apparatuur die jouw
                    eigendom is of waarover je mag beschikken en uitsluitend met gebruikmaking van het daarvoor
                    goedgekeurde besturingssysteem (zoals Apple iPhone OS voor apparatuur van Apple). Als je
                    een account aanmaakt voor de onlinediensten ben je verantwoordelijk voor het waarborgen
                    van de veiligheid van de account en van alle activiteiten die in het kader van het account
                    plaatsvinden. Je mag slechts één account voor onlinediensten gebruiken en je dient ervoor te
                    zorgen dat je accountgegevens te allen tijde up-to-date zijn.
                  </p>
                  <p>
                    <strong>Het recht van McDonald’s om de onlinediensten bij te werken of te beëindigen.</strong> Je begrijpt en
                    stemt ermee in dat McDonald’s (met of zonder berichtgeving) de onlinediensten (of jouw
                    toegang tot die diensten) van tijd tot tijd mag bijwerken, aanpassen of beëindigen, onder
                    andere door het versturen van pushberichten met updates voor (of voor het verwijderen van
                    de functionaliteit van of toegang tot) de mobiele app van McDonald’s die je op je toestel hebt
                    geïnstalleerd.
                  </p>
                  <p>
                    <strong>Bijwerken van deze voorwaarden.</strong> Daarnaast kan McDonald’s deze voorwaarden te allen tijde
                    en geheel naar eigen discretie bijwerken. Indien McDonald’s materiële wijzigingen aanbrengt in
                    de voorwaarden, berichten we je daarover op een redelijke wijze, bijvoorbeeld door de nieuwe
                    voorwaarden in de onlinediensten te plaatsen. Wanneer je niet akkoord gaat met de gewijzigde
                    voorwaarden, dien je het gebruik van de onlinediensten onmiddellijk te staken en McDonald’s
                    te verzoeken een eventueel door jou aangemaakte account voor de onlinediensten af te
                    sluiten. Je kunt je App accountinstellingen inzien, wijzigen of verwijderen via de volgende
                    website: <a
                      href='https://www.mcdonaldsapps.com/en-GB/account'>www.mcdonaldsapps.com/account</a>. Mocht je vragen hebben dan kun je contact
                    opnemen met onze afdeling <a
                      href='https://www.mcdonalds.com/nl/nl-nl.html'>Gastenrelaties</a>, we helpen je graag.
                  </p>
                  <p>
                    <strong>Veel restaurants zijn in handen van en worden geëxploiteerd door onafhankelijke bedrijven. </strong>
                    McDonald’s bestuurt en beheert weliswaar de onlinediensten, maar zij is niet verantwoordelijk
                    voor de bedrijfsvoering van de meeste restaurants. De meeste restaurants zijn namelijk in
                    handen van en worden geëxploiteerd door onafhankelijke franchisenemers van McDonald’s, en
                    sommige worden geëxploiteerd door dochtermaatschappijen van McDonald’s (hierna worden
                    deze franchisenemers en dochtermaatschappijen gezamenlijk aangeduid met “restaurants”).
                    Elk restaurant is zelf verantwoordelijk voor het naleven van wet- en regelgeving, voor kwesties
                    met betrekking tot de levering van de producten aan jou en voor werknemer gerelateerde
                    zaken in het restaurant. Op de bon kun je de volledige naam en adresgegevens van het
                    restaurant vinden.
                  </p>
                  <p>
                    <strong>Links naar vacatures vanuit de onlinediensten. </strong>
                    McDonald’s en alle restaurants zijn werkgevers
                    die een beleid voeren van gelijke kansen voor verschillende soorten werknemers. De
                    onlinediensten kunnen links bevatten naar vacatures die door McDonald’s of door restaurants
                    zijn geplaatst. Deze vacatures gelden alleen voor het restaurant (met andere woorden: voor de
                    dochtermaatschappij of de franchisenemer) en niet voor McDonald’s of het moederbedrijf
                    daarvan (McDonald’s Corporation). Dat betekent dat uitsluitend het restaurant dat de vacature
                    heeft geplaatst, verantwoordelijk is voor het vaststellen van de functie-eisen, de besluitvorming
                    over het aannemen van personeel, en alle overige personeelszaken binnen zijn bedrijf.
                    McDonald’s en haar moederbedrijf ontvangen geen kopie van de sollicitatie die je verstuurt aan
                    een restaurant dat een franchisenemer is; zij hebben geen invloed op de beslissing of je al dan
                    niet wordt uitgenodigd voor een sollicitatiegesprek en of je wordt aangenomen, en ook niet op
                    het werknemersbeleid van franchisenemers. McDonald’s en haar moederbedrijf hebben geen
                    onafhankelijke franchisenemers in dienst. Wanneer je een baan krijgt aangeboden door een
                    restaurant dat een franchisenemer is, is alleen die franchisenemer je werkgever, en niet
                    McDonald’s of haar moederbedrijf (McDonald’s Corporation).
                  </p>
                  <p>
                    <strong>Contact met ons opnemen.</strong> Mocht je vragen of opmerkingen hebben over onze onlinediensten
dan kun je contact opnemen met onze afdeling <a
                      href='https://www.mcdonalds.com/nl/nl-nl.html'>Gastenrelaties</a>.
                  </p>
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                <h2>2. Hoe wij omgaan met informatie en onze communicatie met jou.</h2>
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="extendable_content">
                  <p>
                    <strong>De Privacyverklaring van McDonald’s.</strong> Op deze voorwaarden is tevens <a
                      href='https://www.mcdonalds.com/us/en-us/privacy.html'>de Privacyverklaring van McDonald’s van
                    toepassing</a>, die een integraal onderdeel vormt van deze voorwaarden. In onze
                    Privacyverklaring staat beschreven hoe wij omgaan met gegevens, waaronder begrepen het
                    verzamelen, gebruiken en delen van gegevens.
                  </p>
                  <p>
                    <strong>Onze communicatie met jou.</strong> Via de onlinediensten kan je aangeven dat je e-mails en sms’jes
                    wilt ontvangen op het mobiele nummer dat je aan ons hebt opgegeven, of dat je pushberichten
                    van McDonald’s wilt ontvangen. Wanneer je jezelf aanmeldt voor een van deze vormen van
                    communicatie begrijp je en stem je ermee in dat je reclame-, transactie-, en andere berichten
                    van McDonald’s zult ontvangen. McDonald’s kan in overeenstemming met <a
                      href='https://www.mcdonalds.com/us/en-us/privacy.html'>de Privacyverklaring van
                    McDonald’s</a> gebruikmaken van de gegevens die je aan ons hebt verstrekt om met jou te
                    kunnen communiceren.
                  </p>
                  <p>
                    <strong>Afmelden voor berichtgeving in het algemeen.</strong> Je kunt kiezen hoe we met jou communiceren.
                    Meestal vind je jouw voorkeursinstellingen met aanwijzingen hoe je jezelf kan afmelden in het
                    profiel van de door jou gebruikte onlinedienst. Je kunt eventueel ook je voorkeursinstellingen
                    wijzigen in de instellingen van je toestel. Daarnaast kan in onze berichten ook een afmeld-optie
                    zijn opgenomen. Je begrijpt en gaat ermee akkoord dat je jouw voorkeursinstellingen wellicht
                    afzonderlijk moet beheren voor elke vorm van communicatie. Als je jezelf bijvoorbeeld afmeldt
                    voor het ontvangen van reclamemails, kan je nog steeds reclame-sms’en ontvangen als je jezelf
                    daarvoor hebt aangemeld. Wij doen ons best om handige manieren aan te bieden voor het
                    beheren van je voorkeursinstellingen voor je communicatie met ons, maar het kan toch
                    gebeuren dat je jouw voorkeursinstellingen voor elke onlinedienst afzonderlijk moet
                    aanpassen. Wij wijzen erop dat er voor sommige account gerelateerde en transactieberichten
                    alleen de mogelijkheid bestaat om je account voor onlinediensten af te sluiten, als je deze
                    berichten niet meer wilt ontvangen. Ten slotte wijzen wij er nog op dat als je berichten van een
                    franchisenemer van McDonald’s ontvangt, je jezelf rechtstreeks bij hem moet afmelden.
                  </p>
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                <h2>3. MyOrder</h2>
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="extendable_content">
                  <p>Dit gedeelte is van toepassing op alle bestellingen die je plaatst met behulp van de
                    MyMcDonald’s App. Het bestellen via de MyMcDonald’s App heet MyOrder. Lees dit gedeelte
                    van de Algemene Voorwaarden door voordat je een MyOrder bestelling plaatst bij één van de
                    deelnemende restaurants. Houd er rekening mee dat het bestellen via de MyMcDonald’s App
                    mogelijk niet in alle restaurants beschikbaar zal zijn. Zie de <a
                      href='https://veelgesteldevragen.mcdonaldsnederland.app/'>FAQ's</a> in de McDonald’s App voor
                    meer informatie over MyOrder.
                  </p>
                  <p>
                    <strong>Over MyOrder.</strong> Het doel van MyOrder is om gasten een makkelijke manier te bieden om
                    van
                    tevoren bestellingen samen te stellen en deze bij bestellingen bij een deelnemend restaurant te
                    plaatsen.
                  </p>
                  <p>
                    Om een bestelling te kunnen plaatsen via de MyMcDonald’s App moet je een geregistreerd
                    account hebben. De volgende persoonsgegevens zijn vereist voor registratie: voor-en
                    achternaam en e-mailadres.
                  </p>
                  <p>
                    <strong>Uw betaalmethode registreren.</strong> Afhankelijk van het door jou gekozen betaalmiddel (Apple Pay,
                    Google Pay, Credit Card of iDeal) moet je mogelijk jouw kaart- of betalingsgegevens registreren
                    om te kunnen bestellen.
                    McDonald's en de restaurants maken gebruik van externe partners om jouw betaalkaart-en
                    betalingsgegevens veilig op te slaan en jouw betalingen aan de restaurants te verwerken.
                    Je begrijpt en gaat ermee akkoord dat, wanneer je een betaalkaart of betaalmiddel registreert,
                    McDonald's of haar externe partners kunnen controleren of de door jou geregistreerde
                    gegevens geldig zijn.
                    Je verklaart en garandeert dat je meerderjarig bent. En dat je daarnaast gerechtigd bent om alle
                    betaalkaarten die je registreert of meebetaald ook te gebruiken.
                  </p>
                  <p>
                    <strong>Je koopt producten rechtstreeks van restaurants.</strong> Wanneer je gebruik maakt van MyOrder,
                    zend je de bestellingen rechtstreeks aan een deelnemend restaurant en het contract voor de
                    koop en levering van de producten wordt dan ook gesloten tussen jou en het restaurant dat
                    jouw bestelling accepteert. Het restaurant waar je jouw producten afhaalt, is verantwoordelijk
                    voor het bereiden van de producten en de levering daarvan aan jou. Je begrijpt verder en gaat
                    ermee akkoord dat je rechtstreeks van de restaurants koopt (en niet van McDonald's
                    Corporation of een andere aan McDonald’s Corporation gelieerde McDonald's entiteit) en dat
                    noch McDonald's Corporation noch een andere aan McDonald’s Corporation gelieerde McDonald’s entiteit enige verantwoordelijkheid draagt ten aanzien van of verband houdende
                    met producten die je koopt van restaurants via MyOrder.
                  </p>
                  <p>
                    <strong>Jouw producten selecteren, bestelling betalen en verzenden naar een restaurant.</strong> Je kunt de
                    gewenste producten in de MyMcDonald’s App toevoegen aan jouw bestelling. Indien je de
                    items wenst te bestellen, dan kun je deze aansluitend verzenden naar een deelnemend
                    restaurant van jouw keuze. Wanneer je op “Bestel en betaal nu” in de MyMcDonald’s App
                    drukt, dan wordt de aankoop definitief en wordt het betaalmiddel belast met het
                    aankoopbedrag. Je ontvangt na het plaatsen van jouw bestelling een bestelcode, maar de
                    restaurants kunnen mogelijke ook andere informatie nodig hebben om jouw aankoop te
                    verifiëren. Bestellingen moeten persoonlijk worden opgehaald bij het geselecteerde restaurant.
                  </p>
                  <p>
                    <strong>Opties voor je bestelling.</strong> Je kunt de volgende opties kiezen om je online bestelling op te halen:
                  </p>
                  <ul>
                    <li>curbside (zijnde buiten op een aangewezen plaats en thans nog niet beschikbaar in
                      Nederland),
                    </li>
                    <li>in de McDrive (thans nog niet beschikbaar in Nederland),</li>
                    <li>aan de front counter; of</li>
                    <p>via table service.</p>
                  </ul>
                  <p>
                    <strong>Je bestelling voorbereiden.</strong> Alle producten zijn afhankelijk van de beschikbaarheid in het
                    restaurant waar je jouw bestelling plaatst en ophaalt. Als je het restaurant selecteert, zie je de
                    serveertijd voor het ontbijt of het hoofdmenu van dat restaurant. Als je de afhaaloptie voor de
                    front counter of McDrive selecteert, dan zie je tevens de serveertijden voor elke optie
                    (bijvoorbeeld tussen 6.00 uur – 0:00 uur). Als je aankomt nadat het restaurant gesloten is, kun
                    je jouw bestelling niet ophalen en wordt de gedane betaling niet terugbetaald. Zorg er daarom
                    voor dat je op tijd kunt zijn voordat je jouw bestelling bevestigt en betaalt.
                  </p>
                  <p>
                    Wanneer je jouw bestelling plaatst om af te halen bij de Afhaal zone in het restaurant, krijg je
                    een bericht te zien waarin staat hoeveel minuten er ongeveer nodig zijn om je bestelling te
                    bereiden. Als je je locatievoorzieningen hebt geactiveerd en je te ver van het restaurant bent,
                    zie je een bericht dat je te ver van het restaurant bevindt en we direct aan de slag gaan met
                    jouw bestelling na betaling. Zorg ervoor dat je op tijd komt. Zodra je hebt bevestigd en betaald,
                    word je bestelling klaargemaakt en kan deze niet meer geannuleerd worden.
                  </p>
                  <p>
                    Als je jouw bestelling plaatst om af te halen via de McDrive, bevestig je jouw bestelling en
                    betaal je deze vooraf, maar jouw bestelling wordt wel pas klaargemaakt nadat je bij de door jou
                    geselecteerde McDrive bent aangekomen en je bij de praatpaal jouw bestelcode hebt
                    doorgegeven. Als je afhalen via de McDrive selecteert en je arriveert na de eindtijd van het
                    door jou bestelde menu-item (bijv. na de sluiting van het ontbijtmenu) of als één van de door
                    jou geselecteerde producten niet meer beschikbaar is, dan zal een crewmember je verder
                    helpen. Het is in dat geval helaas niet mogelijk om de bestelde producten uit te serveren.
                  </p>
                  <p>
                    Als je jouw bestelling plaatst voor afhalen door middel van Curbside of voor bediening aan tafel,
                    moet je bij aankomst je parkeervak- of tafelnummer invoeren in de MyMcDonald’s App voordat
                    je kunt betalen. Zodra je jouw bestelling hebt bevestigd en betaald, word je bestelling
                    klaargemaakt. Zodra de bestelling klaar is, zal een medewerker je begroeten bij het parkeervak
                    of de tafel en jouw bestelling afgeven.
                  </p>
                  <p>
                    Sommige restaurants verkopen niet alle producten. Afbeeldingen van producten en
                    verpakkingen in de MyMcDonald’s App zijn slechts voorbeelden en komen mogelijk niet
                    overeen aan het product of de verpakking die je van het restaurant ontvangt. Verschillen
                    kunnen te wijten zijn aan de weergave van kleuren op je apparaat of aan factoren zoals de
                    gebruikte ingrediënten, de leverancier, de regio van het land, tijdstip van de dag en het seizoen
                    van het jaar.
                  </p>
                  <p>
                    <strong>Over de prijzen bij het bestellen.</strong> Elk restaurant bepaalt onafhankelijk zijn eigen prijzen en past
                    onafhankelijk eventuele aanvullende belastingen en heffingen toe zoals wettelijk vereist. Het is
                    mogelijk dat bepaalde aanbiedingen en prijzen niet beschikbaar zijn voor alle bestellingen op
                    alle locaties. Als je een fout ontdekt in de prijs van een product dat aan jou in rekening is
                    gebracht, neem dan contact op met het restaurant waar je het product hebt gekocht om het
                    verschil terug te krijgen.
                  </p>
                  <p>
                    <strong>Locatiediensten.</strong> Schakel je locatieservices in op jouw apparaat om te profiteren van de
                    automatische selectie van het dichtstbijzijnde restaurant en om een locatiecontrole te
                    ontvangen wanneer je te ver weg bent van het restaurant dat je als afhaaloptie hebt gekozen.
                    Als jouw locatieservices niet zijn ingeschakeld of als je niet bij het dichtstbijzijnde restaurant
                    wilt bestellen, kun je handmatig een restaurant naar keuze selecteren.
                  </p>
                  <p>
                    <strong>Betalen voor je bestelling.</strong> Wanneer je "Bestel en betaal nu" opgeeft, geef je het restaurant
                    toestemming om je bestelling te verwerken. De betalingsdienstaanbieder van het restaurant zal
                    je betaling verwerken en het bedrag in rekening brengen op de betaalkaart die je hebt
                    geselecteerd toen je jouw bestelling plaatste. Mogelijk ontvang je een melding in de
                    bestelfunctie dat het restaurant je bestelling heeft geaccepteerd en deze aan het voorbereiden
                    is. Je bent pas eigenaar van de producten nadat je ze hebt opgehaald.
                  </p>
                  <p>
                    <strong>Wat moet ik doen als ik een probleem heb met een betaling of mijn geld terug wil?</strong> Neem
                    contact op met je bank als je vragen hebt over kosten die worden weergegeven op het afschrift
                    van je betaalkaart, betaalrekening of als je een restauranttransactie wilt betwisten voor een
                    bedrag dat in rekening is gebracht op je betaalkaart. Je bank kan je adviseren over het beleid
                    van je bank en kan je vertellen wanneer ze gereserveerde bedragen vrijgeven.
                  </p>
                  <p>
                    <strong>Wat moet ik doen als ik vermoed dat er frauduleuze activiteiten plaatsvinden op mijn
                      rekening?</strong> Als je denkt dat er onjuiste of ongeautoriseerde kosten op je rekening staan, moet je
                    onmiddellijk contact opnemen met je bank. Je moet ook onmiddellijk jouw wachtwoord
                    bijwerken. Beveiligingsexperts raden mensen aan om wachtwoorden complex te maken en
                    voor elke account een andere gebruikersnaam en wachtwoord te gebruiken.
                  </p>
                  <p>
                    <strong>Annuleren, restitutie en jouw rechten als consument.</strong> Je kunt tot het moment dat je jou
                    bestelling hebt bevestigd en betaald, jouw bestelling wijzigen of annuleren. Zodra je jouw
                    bestelling hebt bevestigd en betaald, kun je deze niet meer wijzigen en/of annuleren. Als je
                    jouw geld wilt terugvragen (om welke reden dan ook, bijvoorbeeld omdat je ontevreden bent
                    over de kwaliteit van de producten) neem dan contact op met het restaurant waar je het
                    product hebt gekocht.
                  </p>Jouw wettelijke rechten in dit opzicht worden door niets in deze voorwaarden aangetast.<p>

                  </p>
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                <h2>4. MyMcDonald’s programma</h2>
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="extendable_content">
                  <p>
                    <strong>Algemeen.</strong> De voorwaarden uit dit hoofdstuk zijn van toepassing op het MyMcDonald’s
                    programma.
                  </p>
                  <p>
                    <strong>Voorwaarden en deelname.</strong> Om mee te kunnen doen aan het MyMcDonald’s programma dien
                    je een account aan te maken en te registreren voor onlinediensten van McDonald’s. Gasten die
                    voorafgaand aan het MyMcDonald’s Rewards programma reeds een geregistreerd account
                    hadden, worden opnieuw gevraagd of zij hun persoonlijke account willen voortzetten en op die
                    manier willen profiteren van persoonlijke MyMcDonald’s Deals en MyMcDonald’s Rewards.
                  </p>
                  <p>
                    <strong>Aanbiedingen.</strong> Je kunt via de onlinediensten aanbiedingen ontvangen. De volgende
                    algemene voorwaarden zijn van toepassing op aanbiedingen: (1) de aanbieding is wellicht uitsluitend
                    beschikbaar via die bepaalde onlinedienst en voor het afgebeelde product, en zolang de voorraad
                    strekt, uitsluitend in deelnemende restaurants, en tot aan de vervaldatum; (2) bepaalde tijdblokken
                    kunnen van toepassing zijn (bijv. aanbiedingen die geen ontbijt zijn, zijn tijdens ontbijturen
                    wellicht niet beschikbaar); (3) voor zover niet anders wordt aangegeven vervalt elke aanbieding na
                    gebruikmaking daarvan; (4) per restaurantbezoek mogen er meerdere Deals ingewisseld worden, maar
                    elke Deal kan maar één keer ingeleverd worden. (5) aanbiedingen zijn niet overdraagbaar; en (6) een
                    aanbieding kan niet voor geld worden ingewisseld. Daarnaast kunnen er voor een aanbieding bijzondere
                    voorwaarden gelden; deze worden in de app naast de aanbieding vermeld. Niet alle aanbiedingen kunnen
                    worden gecombineerd met bestellingen.
                  </p>
                  <p>
                    <strong>Het inwisselen van een MyMcDonald’s Deal.</strong> Je kunt een MyMcDonald’s Deal inwisselen
                    wanneer je jouw bestelling plaatst door de Deal te activeren en bij de kassa of kiosk de Deal QR
                    code te scannen of door in de McDrive jouw QR code te scannen, dan wel de alfanumerieke
                    code voor te lezen aan het crewlid dat jouw bestelling opneemt, wanneer het scannen van de
                    QR code niet werkt.
                  </p>
                  <p>Je kunt géén MyMcDonald’s Deals inwisselen bij de twee McDonald’s restaurants achter de
                    douane op Schiphol of bij bestellingen via McDelivery.</p>
                  <p>
                    <strong>Het sparen van MyMcDonald’s Punten.</strong> Je verdient MyMcDonald’s punten op basis van de
                    waarde van jouw bestellingen, namelijk 10 punten per € 1,00. Je kunt géén MyMcDonald’s
                    punten verdienen over gedane donaties, betaalde statiegelden en bij de aankoop van een
                    cadeaucard (je spaart wel MyMcDonald’s punten als je met de cadeaucard je bestelling
                    afrekent.)
                  </p>
                  <p>
                    Je kunt MyMcDonald’s punten verdienen wanneer je vóór het afrekenen van jouw bestelling bij
                    de kassa of kiosk jouw digitale MyMcDonald’s card scant of door in de McDrive jouw digitale
                    MyMcDonald’s card te scannen, dan wel de alfanummerieke code van jouw digitale McDonald’s
                    MyMcDonald’s Rewards card voor te lezen aan het crewlid dat jouw bestelling opneemt,
                    wanneer het scannen de QR code niet werkt. De MyMcDonald’s punten worden op basis van de
                    afgerekende bestelling bijgeschreven. Mogelijk zit er een kleine vertraging op de zichtbaarheid
                    van de verdiende MyMcDonald’s punten in jouw account.
                  </p>
                  <p>
                    Ter voorkoming van fraude en/of misbruik kan een gast maximaal 3 keer per dag op
                    bovenstaande wijze punten verdienen.
                  </p>
                  <p>
                    Wanneer je dit proces tijdens het plaatsen van jouw bestelling niet of niet op de juiste wijze
                    doorloopt, dan kunnen er géén MyMcDonald’s punten bij je saldo worden bijgeschreven.
                  </p>
                  <p>
                    Je kunt géén MyMcDonald’s punten sparen bij de twee McDonald’s restaurants achter de
                    douane op Schiphol of bij bestellingen via McDelivery.
                  </p>
                  <p>
                    <strong>Bonus campagnes of promoties.</strong> Van tijd tot tijd kan McDonald’s speciale campagnes
                    of
                    promoties houden, waarbij er MyMcDonald’s punten op nieuwe en andere manieren verdiend
                    kunnen worden. Verdere informatie over dergelijke campagnes of promoties wordt verstrekt in
                    de context van de betreffende campagne of promotie.
                  </p>
                  <p>
                    <strong>Maximum aantal punten.</strong> Jouw account kent een maximum van 10.000 punten (“Punten
                    Plafond”). Wanneer je een voor MyMcDonald’s punten in aanmerking komende bestelling
                    plaatst en daarmee het Rewards Plafond bereikt, dan verdien je géén Rewards punten over het
                    meerdere. Wanneer je een voor MyMcDonald’s Rewards in aanmerking komende bestelling
                    plaatst, terwijl je het Rewards Plafond al hebt bereikt, verdien je géén punten. Je kunt in dat
                    geval pas nieuwe MyMcDonald’s punten sparen, nadat je MyMcDonald’s punten hebt
                    ingewisseld.
                  </p>
                  <p>
                    <strong>Inwisselen van Rewards.</strong> Je kunt jouw MyMcDonald’s punten inwisselen bij deelnemende
                    McDonald’s restaurants voor Rewards, zijnde producten uit het MyMcDonald’s Rewards Menu
                    (“Inwisselbare producten”) van de McDonald’s app. Je hebt de app nodig om MyMcDonald’s
                    punten in te wisselen voor de Rewards uit het MyMcDonald’s Rewards Menu.
                  </p>
                  <p>Je kunt je punten inwisselen door de Reward in de App te activeren en bij de kassa of kiosk de
                    QR code te scannen of door in de McDrive de QR code te scannen, dan wel de alfanumerieke
                    code voor te lezen aan het crewlid dat jouw bestelling opneemt, wanneer het scannen van de
                    QR code niet werkt.</p>
                  <p>Je kunt géén MyMcDonald’s punten inwisselen bij de twee McDonald’s restaurants achter de
                    douane op Schiphol of bij bestellingen via McDelivery.</p>
                  <p>
                    <strong>MyMcDonald’s Rewards menu.</strong> Het MyMcDonald’s Rewards menu geeft een weergave van de
                    inwisselbare producten en hoeveelheid MyMcDonald’s punten die ingewisseld dienen te
                    worden om deze Rewards te krijgen.
                  </p>


                  <p>
                    <strong>MyMcDonald’s Fanshop.</strong> Je kunt jouw MyMcDonald’s punten ook inwisselen in de
                    MyMcDonald’s Fanshop in de McDonald’s App. De MyMcDonald’s Fanshop is gevuld met
                    speciale limited edition McDonald’s Merchandise, waarbij er per product vermeld staat hoeveel
                    MyMcDonald’s punten er ingewisseld dienen te worden om deze producten te bemachtigen.
                    Let op: het aanbod van de speciale limited edition McDonald’s Merchandise wisselt regelmatig
                    en het aanbod om MyMcDonald’s punten in te wisselen voor de speciale limited edition
                    McDonald’s Merchandise van jouw keuze geldt zolang de voorraad strekt.
                  </p>

                  <p>Je kunt je punten inwisselen voor McDonald’s Merchandise door in de McDonald’s App de
                    MyMcDonald’s Fanshop te openen en het product te selecteren, je keuze voor dit product
                    uitdrukkelijk te bevestigen en daarna je gegevens(*) achter te laten.</p>
                  <p>Vervolgens komt er een overeenkomst tot stand tussen jou en McDonald’s Nederland B.V.
                    (Stadsplateau 31-32, 3521 AZ Utrecht). De toezending van de producten zal verlopen via een
                    door McDonald’s ingeschakelde derde. Deze zal het product vervolgens binnen 2 à 3 weken,
                    met reguliere post, versturen.</p>
                  <p>Indien het product niet wordt ontvangen, dan kun je binnen 6 weken na inwisseling van de
                    punten contact op te nemen met gastenrelaties@nl.mcd.com. De door McDonald’s
                    ingeschakelde derde zal het product – indien nog op voorraad – in dat geval nogmaals
                    verzenden. Als het product niet langer op voorraad is, zullen de ingewisselde punten worden
                    gerestitueerd.</p>
                  <p>Als er onverhoopt iets mis zijn gegaan en je hebt een gebrekkig product ontvangen, dan kun je
                    contact op te nemen met gastenrelaties@nl.mcd.com. Zij zullen je klacht dan behandelen.
                    Indien je recht hebt op een vervangend product, dan zal de door McDonald’s ingeschakelde
                    derde het product – indien nog op voorraad – nogmaals verzenden. Als het product niet langer
                    op voorraad is, zullen de ingewisselde punten worden gerestitueerd.</p>
                  <p>Daarnaast kun je binnen 14 dagen na ontvangst van het product gebruik maken van jouw
                    herroepingsrecht ex artikel 6:230o BW. Vul het meegezonden ingevulde Model
                    Herroepingsformulier in en stuur het pakketje naar McDonald’s Nederland, t.a.v. Gastenrelaties
                    / McDonald’s Fanshop, Stadsplateau 31-32, 3541 AZ Utrecht. De directe kosten voor de
                    retourzending komen voor jouw eigen rekening. Binnen 14 dagen na ontvangst van de retour
                    gezonden producten, zal McDonald’s, mits de producten ongebruikt zijn, de ingewisselde
                    punten restitueren en opnieuw bijschrijven bij het saldo.</p>

                  <p>(*) de verstrekte persoonsgegevens worden binnen 6 maanden na verzending verwijderd uit de systemen.</p>


                  <p>
                    <strong>Het vervallen van MyMcDonald’s punten.</strong> MyMcDonald’s punten dienen binnen 12 maanden
                    ingewisseld te worden. De punten vervallen tegen het einde van de kalendermaand waarin de
                    punten 12 maanden oud zijn.
                  </p>
                  <p>
                    <strong>Restitutie.</strong> McDonald’s is bevoegd om MyMcDonald’s punten van jouw account te verwijderen,
                    wanneer de door jouw aangeschafte en in aanmerking voor MyMcDonald’s punten komende
                    producten worden geretourneerd en er een gehele of gedeeltelijke terugbetaling van het
                    aankoopbedrag volgt. Dit geldt ook voor het omwisselen van producten, tenzij de producten
                    worden omgewisseld voor een ander product met dezelfde hoeveelheid MyMcDonald’s
                    punten.
                  </p>
                  <p>
                    <strong>Verdachte activiteiten.</strong> McDonald’s is bevoegd om alle maatregelen te nemen die zij
                    noodzakelijk acht, waaronder het verwijderen of schorsen van jouw account en/of de door jou
                    verzamelde MyMcDonald’s punten, wanneer zij verdachte activiteiten constateert of misbruik
                    van de Dienst. Als verdachte activiteiten en/of misbruiken worden in ieder geval (maar niet
                    uitsluitend) gerekend:
                  </p>
                  <ol type='i'>
                    <li>Deelname aan illegale of frauduleuze activiteiten, of</li>
                    <li>Het verstrekken of het proberen te verstrekken van valse en/of misleidende
                      informatie of het geven van verkeerde voorstelling van zaken aan McDonald’s en/of
                      de deelnemende McDonald’s restaurants, of
                    </li>
                    <li>Het verkopen, toewijzen, overdragen of verkrijgen of het aanbieden van het
                      verkopen, toewijzen, overdragen of verkrijgen van enige MyMcDonald’s Rewards of
                      punten, anders dan in overeenstemming met deze algemene voorwaarden, of
                    </li>
                    <li>Het excessief verdienen van punten (via fraude, door punten te scannen van
                      anderen of via andere wijzen)</li>
                    <li>Elk gebruik van McDonald’s advertenties en promotiematerialen of delen daarvan,
                      McDonald’s intellectuele eigendomsrechten aangaande die advertenties en
                      promotiematerialen, anders dan uitdrukkelijk toegestaan in deze voorwaarden.
                    </li>
                  </ol>
                  <p>
                    <strong>Diversen</strong>
                  </p>
                  <p>
                    De MyMcDonald’s punten hebben geen enkele monetaire waarde en zijn niet overdraagbaar.
                  </p>
                  <p>
                    McDonald’s behoudt zich het recht voor om het MyMcDonald’s Rewards programma, de
                    MyMcDonald’s Deals en/of de MyMcDonald’s Rewards, stop te zetten.
                  </p>
                  <p>
                    McDonald’s behoudt zich het recht voor om het wisselen van MyMcDonald’s Deals en/of
                    MyMcDonald’s Rewards te weigeren, wanneer zij vermoedt dat er gefraudeerd is met de App.
                  </p>
                  <p>
                    Een account wordt beëindigd bij overlijden van de gebruiker. De verdiende maar nog niet
                    geclaimde of ingewisselde MyMcDonald’s Deals en/of MyMcDonald’s punten komen daarbij te
                    vervallen. McDonald’s verwijdert het MyMcDonald’s account na notificatie van overlijden.
                    McDonald’s is niet aansprakelijk voor enig verlies of schade van enige partij ten gevolge van
                    deze verwijdering.
                  </p>
                  <p>
                    McDonalds behoudt te allen tijde het eigenaarschap van al haar materialen en advertenties in
                    relatie tot de MyMcDonald’s programma evenals alle intellectueel eigendomsrechten van alle
                    materialen en advertenties in relatie tot het MyMcDonald’s programma.
                  </p>
                  <p>
                    Door deel te nemen aan het MyMcDonald’s programma accepteer je de onderhavige Algemene
                    voorwaarden voor de Onlinediensten van McDonald’s.
                  </p>
                  <p>
                    Géén van de bepalingen uit deze afdeling is van invloed op jouw dwingendrechtelijke rechten.
                  </p>
                  <p>
                    Alle informatie en voorwaarden op advertenties en/of promotiematerialen ten aanzien van
                    deze dienst, maken onderdeel uit van deze Algemene voorwaarden, met dien verstande dat in
                    geval van botsingen tussen de informatie en voorwaarden op advertenties en
                    promotiematerialen de tekst van deze algemene voorwaarden prevaleren.
                  </p>
                  <p>
                    <strong>Promotor:</strong> McDonald’s Nederland B.V. en McDonald’s Marketing Coöperatie
                  </p>
                  <p>
                    Je hebt op elk moment de mogelijkheid om je account te verwijderen door jezelf uit te loggen
                    in de App en via de link om verwijdering van je account te verzoeken. Of neem via
                    <a href="mailto:privacy@nl.mcd.com"> privacy@nl.mcd.com</a> contact op met de Chief Privacy Officer
                    van McDonald’s Nederland met
                    het verzoek jouw account te verwijderen. Na verwijdering van je account vervallen alle
                    MyMcDonald’s persoonlijke Deals en alle gespaarde MyMcDonald’s punten. Zodoende
                    adviseren wij je om een eventuele verwijdering van je account zorgvuldig te plannen. Vervallen
                    MyMcDonald’s Deals of MyMcDonald’s punten worden namelijk niet vergoed.
                  </p>
                  <p>
                    <strong>Je koopt producten rechtstreeks van restaurants.</strong> Wanneer je gebruikmaakt van aanbiedingen
                    doe je dat rechtstreeks met een deelnemend restaurant en komt er een overeenkomst tot
                    stand voor de levering van de producten tussen jou en het restaurant dat jouw bestelling
                    aanvaardt (dus niet met McDonald’s of een ander Lid van het McDonald’s Systeem). Het
                    restaurant waar je jouw producten ophaalt is verantwoordelijk voor de bereiding van de
                    producten en de levering daarvan aan jou. McDonald’s Corporation (het moederbedrijf van
                    McDonald’s), haar dochtermaatschappijen, de aan haar gelieerde bedrijven, hun
                    franchisenemers, vertegenwoordigers, agenten en agentschappen en hun functionarissen,
                    bestuurders en werknemers vormen samen de “Leden van het McDonald’s Systeem”.
                  </p>
                  <p>
                    <strong>De producten in de onlinediensten.</strong> Alle producten zijn onder voorbehoud van beschikbaarheid
                    in het restaurant waar je jouw bestelling ophaalt. Sommige restaurants verkopen niet alle
                    producten. Afbeeldingen van producten en verpakkingen in de onlinediensten zijn niet meer
                    dan een voorbeeld en kunnen afwijken van het product of de verpakking die je van het
                    restaurant ontvangt. Verschillen kunnen te wijten zijn aan de kleurenweergave van je toestel of
                    aan factoren zoals de gebruikte ingrediënten, de leverancier, de regio in het land en het
                    seizoen.
                  </p>
                  <p>
                    <strong>Prijzen bij bestelling.</strong> Elk restaurant stelt zelf zijn prijzen vast en past zelf eventuele lokale
                    belastingen of vergoedingen toe die wettelijk verplicht zijn. Bepaalde aanbiedingen en prijzen
                    zijn wellicht niet voor alle bestellingen op alle locaties beschikbaar. Als je een fout ontdekt in de
                    prijs die aan jou in rekening wordt gebracht voor het product, neem dan contact op met het
                    restaurant waar je het product hebt gekocht en vraag om terugbetaling van het verschil.
                  </p>
                  <p>
                    <strong>Terugbetaling en je rechten als consument.</strong> Als je om welke reden dan ook je geld terug wilt, bijvoorbeeld als je niet tevreden bent over de producten of om een andere reden, neem dan contact op met het restaurant waar je het product hebt gekocht in verband met de aan jou verschuldigde terugbetaling. Je wettelijke rechten in dat verband worden door deze algemene voorwaarden in het geheel niet aangetast.
                  </p>
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                <h2>5. Family Mode</h2>
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="extendable_content">
                  <p>
                    Voor Family Mode geldt in het bijzonder nog dat dit platform uitdrukkelijk gericht is op gezinnen.
                    Gebruikers van de MyMcDonald’s App van 16 jaar of ouder zonder gezin, mogen vanzelfsprekend
                    gebruik maken van de Family Mode module en de features die deze module biedt, maar het is
                    uitdrukkelijk niet de bedoeling dat deze feature zelfstandig wordt gebruikt door kinderen jonger
                    dan 16 jaar, behoudens onder begeleiding van een volwassene.
                  </p>
                  <p>
                    Als McDonald’s op enig moment constateert dat een gebruiker van de MyMcDonald’s App,
                    jonger dan 16 jaar oud is of dat de gebruiker ouder dan 16 jaar maar jonger dan 18 jaar oud is,
                    en de ouder of voogd verklaren geen toestemming te hebben verleend, of de gebruiker kinderen
                    jonger dan 16 jaar zonder begeleiding gebruik laat maken van de McDonald’s App, dan zal
                    McDonald’s overgaan tot blokkade en verwijdering van het account.
                  </p>

                  <p>
                    <strong>Avatars.</strong> Als onderdeel van de Family Mode module kunnen gebruikers avatars maken die het
                    gehele gezin representeren. De avatars kunnen naar vrij inzicht gepersonaliseerd worden. Door
                    deelname aan de (Family Mode) games kan de gebruiker digital goodies (o.a. kledingstukken,
                    accessoires etc.) voor de avatars unlocken.
                  </p>
                  <p>
                    Gebruikers kunnen hun fantasie de vrije loop laten, maar zij zouden er ook voor kunnen kiezen
                    om hun avatars te personaliseren op een wijze die aansluit bij de (uiterlijke) kenmerken van de
                    gezinsleden.
                  </p>
                  <p>
                    Indien de gebruiker ervoor gekozen heeft om de avatars op voornoemde wijze te personaliseren, dan wenst McDonald’s te benadrukken dat zij aan de avatars géén enkele conclusie verbindt rondom de persoon van de gebruiker en/of diens gezinsleden. Eventuele uiterlijke kenmerken, leeftijd, geloofsovertuiging, religie etc. worden op generlei wijze verwerkt. De avatars dienen géén ander doel dan de personalisatie van de Family Mode games voor de gebruiker. McDonald’s verwerkt enkel het aantal gezinsleden met het oog op de personalisatie van eventuele MyMcDonald’s Deals. 
                  </p>

                  <p>
                    <strong>Magic Stories.</strong> In de Family Mode omgeving is het mogelijk om aan de hand van verschillende vooraf vastgestelde parameters gepersonaliseerde digitale voorleesboeken (hierna: “voorleesboeken”) te maken. Deze voorleesboeken worden gegenereerd door middel van het gebruik van AI. Door gebruik te maken van de Magic Story feature in de MyMcDonald’s App, stem je uitdrukkelijk in met het gebruik van AI en met het feit dat deze tool gebruik maakt van de voornamen van de avatars van één of meer gezinsleden om het voorleesboek te personaliseren. 
                  </p>
                  <p>
                    De Magic Stories zijn enkel alleen beschikbaar voor geregistreerde gebruikers van de MyMcDonald’s App en enkel bereikbaar vanuit de App. 
                  </p>
                  <p>
                    De tool is speciaal ontwikkeld voor McDonald’s en het algoritme van de tool wordt niet getraind aan de hand van de door gebruiker geselecteerde input en/of persoonsgegevens. McDonald’s heeft een exclusief gebruiksrecht op de verhalen. Voorts ligt het intellectuele eigendom van de gecreëerde verhalen bij McDonald’s. De voorleesboeken zijn desalniettemin wel uitsluitend bedoeld voor persoonlijk gebruik van de gebruiker en zij worden niet door McDonald’s gebruikt voor enige voor commerciële doeleinden. 
                  </p>
                  <p>
                    McDonald’s behoudt zich het recht voor om deze feature te allen tijde te beëindigen, waarna de geregistreerde gebruiker niet langer beschikking heeft over de gecreëerde voorleesboeken.
                  </p>
                  <p>
                    Bij misbruik van deze feature behoudt McDonald’s zich het recht voor om het account van de gebruiker te blokkeren en/of te verwijderen. 
                  </p>
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                <h2>6. Eigendom van en licenties voor de onlinediensten.</h2>
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="extendable_content">
                  <p>
                    <strong>Intellectuele eigendomsrechten van McDonald’s.</strong> Alle rechten op de onlinediensten zijn en
                    blijven exclusief eigendom van McDonald’s of haar licentiehouders. Voor alle duidelijkheid
                    omvatten “onlinediensten” alle content in de onlinediensten, zoals, maar niet beperkt tot,
                    tekst, beelden, grafische afbeeldingen, logo’s, paginatitels, pictogrammen, beelden,
                    audiofragmenten, digitale downloads, gegevensverzamelingen, software, handelsmerken,
                    dienstmerken, vormgeving, audiobestanden, videobestanden, gegevens en overige materialen
                    (tezamen: “content”) en elk onderdeel van de onlinediensten. De onlinediensten worden niet
                    aan jou verkocht maar in licentie gegeven. Het is geenszins de bedoeling van deze
                    voorwaarden dergelijke rechten aan jou over te dragen of ten behoeve van jou te vestigen. Het
                    is niet toegestaan handelingen te verrichten die de rechten van McDonald’s of haar
                    licentiehouders in gevaar brengen, beperken of daarmee in tegenspraak zijn.
                  </p>
                  <p>
                    <strong>Je licentie voor het gebruik van de onlinediensten.</strong> Met inachtneming van deze voorwaarden
                    verkrijg je een persoonlijke, niet-exclusieve, niet-overdraagbare en herroepbare licentie voor
                    het gebruik van de onlinediensten, uitsluitend voor persoonlijke, niet-zakelijke doeleinden en
                    uitsluitend in overeenstemming met deze voorwaarden. Voor alle duidelijkheid omvat ‘Gebruik’
                    de toegang tot, interacties met en het tonen van de onlinediensten. Behalve de licenties en
                    rechten die wij op grond van deze voorwaarden uitdrukkelijk aan je verlenen worden er geen
                    licenties of rechten aan je verleend op wat voor wijze dan ook. Alle overige rechten worden
                    door McDonald’s voorbehouden.
                  </p>
                  <p>
                    <strong>Handelsmerkgegevens.</strong> De handelsmerken, dienstmerken en alle grafische elementen,
                    waaronder begrepen het uiterlijk en de uitstraling zoals weergegeven in de onlinediensten, zijn
                    karakteristieke en beschermde handelsmerken of handelsstijlen van McDonald’s of
                    licentiehouders. De onlinediensten kunnen daarnaast diverse namen, handelsmerken en
                    dienstmerken van derden bevatten die eigendom zijn van hun respectievelijke eigenaars.
                  </p>
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                <h2>7. Inzendingen van gebruikers en ongevraagde ideeën</h2>
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="extendable_content">
                  <p>
                    <strong>Inzendingen van gebruikers.</strong> Sommige onlinediensten bieden je de mogelijkheid commentaar,
                    opmerkingen, suggesties, ideeën, grafische afbeeldingen, foto’s, vragen, klachten of andere
                    informatie in te zenden die via de onlinediensten naar McDonald’s worden gepost of aan haar
                    worden medegedeeld (tezamen: “inzendingen”). Je begrijpt dat je door het inzenden van
                    gegevens aan McDonald’s via de onlinediensten, McDonald’s een eeuwigdurende,
                    onherroepelijke, wereldwijde, niet-exclusieve royaltyvrije, overdraagbare licentie heeft voor
                    het gebruiken, reproduceren, verspreiden, aan anderen in licentie geven, wijzigen, vertalen,
                    produceren van afgeleide werken, publiekelijk kenbaar maken en publiekelijk uitvoeren van de
                    inzendingen, en deze te gebruiken voor welke commerciële of andere doeleinden dan ook,
                    zonder goedkeuring van of vergoeding aan jou of een ander. McDonald’s is niet verplicht
                    inzendingen vertrouwelijk te behandelen.
                  </p>
                  <p>
                    <strong>Ongevraagde ideeën.</strong> Het beleid van McDonald’s is dat ongevraagde ideeën niet in overweging
                    worden genomen. Wij waarderen het dat je tijd neemt om over McDonald’s na te denken,
                    maar wij kunnen nieuwe ideeën die van buiten het McDonald’s System komen niet beoordelen.
                    Je doet hierbij uitdrukkelijk afstand van alle vorderingen jegens McDonald’s en Leden van het
                    McDonald’s System in verband met het overwegen, gebruiken of ontwikkelen door McDonald’s
                    van producten, ontwerpen, concepten of andere materialen die nu of op enig moment in de
                    toekomst lijken op of gelijk zijn aan jouw inzending. Zie de Veelgestelde Vragen van McDonald’s
                    voor meer informatie.
                  </p>
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                <h2>8. Aanvaardbaar gebruik en beperkingen voor de onlinediensten.</h2>
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="extendable_content">
                  <p><strong>Aanvaardbaar gebruik en andere beperkingen.</strong> De volgende handelingen mag je niet
                    verrichten en je mag derden ook niet toestaan deze te verrichten met betrekking tot de
                    onlinediensten (waaronder begrepen content):</p>
                  <ol type='a'>
                    <li>gebruik van de onlinediensten voor een doel dat onrechtmatig of verboden is op grond van
                      deze voorwaarden;
                    </li>
                    <li>verwijderen of veranderen van auteursrechten, handelsmerken of andere vermeldingen van
                      eigendomsrechten;
                    </li>
                    <li>trachten de titel of eigendom van de onlinediensten te verkrijgen, waaronder begrepen de
                      content;
                    </li>
                    <li>op commerciële wijze gebruiken, kopiëren, verspreiden, opnieuw openbaar maken, tonen,
                      uploaden, plaatsen of doorgeven van de onlinediensten;
                    </li>
                    <li>verhuren, leasen, verkopen, opnieuw in licentie geven, lenen, vertalen, samenvoegen,
                      aanpassen, cederen of overdragen van de onlinediensten, of deze combineren met of
                      toevoegen aan andere programma’s of diensten;
                    </li>
                    <li>disassembleren, decompileren, onderwerpen aan reverse engineering, kopiëren in de
                      broncode- of objectcodeformat van, of het maken van afgeleide werken gebaseerd op de
                      onlinediensten;
                    </li>
                    <li>overdragen, verstrekken, exporteren of opnieuw exporteren van de onlinediensten in strijd
                      met een embargo, handelsbeperking of andere controles op technologie of exportwet-en
                      regelgeving;
                    </li>
                    <li>gebruik of lancering van ongeoorloofde technieken of geautomatiseerde systemen voor het
                      verkrijgen van toegang tot de onlinediensten of het extraheren van content uit de
                      onlinediensten, waaronder begrepen maar niet beperkt tot spiders, robots, screen scrapers,
                      en offline readers;
                    </li>
                    <li>trachten de onlinediensten onklaar te maken, te beschadigen, te overbelasten of te
                      verzwakken of onbevoegde toegang te verkrijgen tot de onlinediensten, het netwerk van
                      McDonald’s of andere gebruikersaccounts voor de onlinediensten.
                    </li>
                  </ol>
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                <h2>9. Aansprakelijkheidsbeperking en vrijwaringen.</h2>
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="extendable_content">
                  <p>
                    <strong>Beperking van de aansprakelijkheid van McDonald’s.</strong> McDonald’s en andere Leden van het
                    McDonald’s System zijn niet aansprakelijk voor directe of indirecte winstderving of
                    bedrijfsschade, voor bijzondere, indirecte of gevolgschade, schadevergoeding, immateriële of
                    bijkomende schade, waaronder begrepen gegevensverlies, persoonlijk letsel of zaakschade
                    verband houdend met of voortvloeiend uit de Onlinediensten. Dit artikel is in geen enkel
                    opzicht bedoeld om de schadevergoedingsplicht van McDonald’s te beperken voor zover
                    schade wordt veroorzaakt door grove schuld, opzet of een onrechtmatig handelen van
                    McDonald’s zelf. Ook is dit artikel geenszins bedoeld als beperking of wijziging van jouw rechten
                    als consument die op grond van toepasselijke wetgeving niet beperkt of gewijzigd kunnen
                    worden. McDonald’s behoudt zich alle wettelijke rechten voor om schade te verhalen of een
                    andere vergoeding te ontvangen op grond van deze voorwaarden of voor zover wettelijk
                    toegestaan.
                  </p>
                  <p>
                    <strong>McDonald’s verleent de onlinediensten “zoals ze zijn” en zonder garanties.</strong> De onlinediensten
                    kunnen onnauwkeurigheden of fouten bevatten. McDonalds verleent de Onlinediensten zoals
                    ze zijn en zonder uitdrukkelijke of stilzwijgende garanties van welke aard dan ook. McDonald’s
                    geeft geen enkele garanties voor de verkoopbaarheid of geschiktheid voor een bepaald doel.
                    McDonald’s garandeert en verklaart niet dat de Onlinediensten correct, betrouwbaar,
                    ononderbroken en foutloos zijn, dat gebreken zullen worden hersteld, of dat de Onlinediensten
                    vrij zijn van virussen of andere schadelijke componenten. Je aanvaardt alle
                    verantwoordelijkheid voor jouw gebruik van de Onlinediensten. Je enige rechtsmiddel jegens
                    McDonald’s en alle overige Leden van het McDonald’s System wanneer je ontevreden bent
                    over de Onlinediensten is dat je het gebruik ervan staakt. Deze beperking van rechtsmiddelen
                    maakt deel uit van de afspraken tussen partijen.
                  </p>
                  <p>
                    <strong>Diensten van derden.</strong> De onlinediensten kunnen links bevatten naar of je toegang geven tot
                    websites, downloadmateriaal, content, sociale netwerken of andere digitale diensten van
                    derden, (tezamen: “diensten van derden”). Deze derden kunnen afzonderlijke voorwaarden of
                    regels van privacybeleid hanteren die je eerst dient te lezen en te begrijpen voordat je
                    gebruikmaakt van die diensten. McDonald’s ondersteunt deze diensten van derden niet en is
                    daar niet bij betrokken. McDonald’s en alle overige Leden van het McDonald’s System zijn niet
                    verantwoordelijk voor verlies of schade voortvloeiend uit of in verband met deze diensten van
                    derden.
                  </p>
                  <p>
                    <strong>Overmacht.</strong> McDonald’s en de andere Leden van het McDonald’s System zijn niet
                    verantwoordelijk wanneer McDonald’s niet aan haar verplichtingen uit hoofde van deze
                    voorwaarden kan voldoen als gevolg van of in verband met een gebeurtenis die redelijkerwijs
                    buiten de macht van McDonald’s ligt. Indien zich een dergelijke gebeurtenis voordoet, worden
                    de verplichtingen van McDonald’s uit hoofde van deze voorwaarden opgeschort voor de duur
                    van de gebeurtenis; McDonald’s kan al het redelijke in het werk stellen om een oplossing te
                    vinden waardoor zij ondanks de gebeurtenis aan haar verplichtingen uit hoofde van deze
                    voorwaarden kan voldoen, maar zij is daartoe niet verplicht.
                  </p>
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                <h2>10. Toepassingen van Apple</h2>
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="extendable_content">
                  <p>Deze voorwaarden omvatten en vormen een aanvulling op de algemene voorwaarden van Apple,
                    Inc. (“Apple”) (zie <a
                        href='https://www.apple.com/legal/internet-services/itunes/us/terms.html#service'>http://www.apple.com/legal/itunes/us/terms.html#service</a>),
                    met inbegrip van
                    de daarin opgenomen voorwaarden voor Eindgebruikers van Gelicentieerde Toepassingen
                    (“voorwaarden van Apple”). Als je gebruikmaakt van de onlinediensten via een applicatie van
                    Apple (“Apple-applicatie”), erken je en ga je ermee akkoord dat:</p>
                  <ul>
                    <li>Apple geen enkele verplichting heeft om ondersteunings- of onderhoudsdiensten te verlenen voor de Apple-applicatie. Als je vragen hebt over het onderhoud of de ondersteuning van de Apps van Apple, neem dan contact op met McDonald’s, en niet met Apple, via bovenstaande contactgegevens van de Ondersteuningsdiensten;
                    </li>
                    <li>voor zover in deze voorwaarden niet uitdrukkelijk anderszins is bepaald, alle vorderingen met
                      betrekking tot het bezit of gebruik van de Apple-applicatie tussen jou en McDonald’s gelden
                      (en niet tussen jou, of iemand anders, en Apple); en
                    </li>
                    <li>ingeval een derde beweert dat door jouw bezit of gebruik (in overeenstemming met deze
                      voorwaarden) van de Apple-applicatie inbreuk wordt gepleegd op intellectuele
                      eigendomsrechten, Apple niet verantwoordelijk of aansprakelijk is jegens jou in verband met
                      die vordering;
                    </li>
                    <p>Als de Apple-applicatie die je hebt gekocht niet overeenstemt met de eventuele garantie die
                      daarop van toepassing is, kan je dit melden aan Apple, en kan de aankoopprijs van de Apple-applicatie eventueel aan je worden vergoed, al naar gelang de op dat moment geldende
                      voorwaarden van Apple. Met dat voorbehoud en voor zover wettelijk toegestaan zal Apple
                      geen garanties, voorwaarden of andere bedingen met betrekking tot de Apple-applicatie geven
                      of aangaan en is zij jegens jou niet aansprakelijk voor vorderingen, verliezen, kosten of
                      onkosten van welke aard dan ook in verband met de Apple-applicatie of doordat de Apple-applicatie door jou of iemand anders is gebruikt of doordat op de content daarvan is
                      vertrouwd.</p>
                  </ul>
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                <h2>11. Diverse bepalingen</h2>
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="extendable_content">
                  <ul>
                    <li>McDonald’s geeft geen verklaring af dat de onlinediensten passend of beschikbaar zijn
                      buiten Nederland. Als je gebruikmaakt van de onlinediensten vanaf andere locaties ben je
                      verantwoordelijk voor de naleving van toepasselijke wetgeving.
                    </li>
                    <li>Deze voorwaarden worden beheerst door en geïnterpreteerd naar Nederlands recht,
                      zonder toepassing van de collisieregels. Je stemt onherroepelijk in met de exclusieve
                      bevoegdheid van de rechter in Amsterdam, Nederland in geval van gerechtelijke procedures
                      voortvloeiend uit of in verband met deze voorwaarden of de onlinediensten.
                    </li>
                    <li>Deze voorwaarden zijn van toepassing op de onlinediensten zoals deze tussen McDonald’s
                      en jou gelden (en noch Apple, noch de andere Leden van het McDonald’s System zijn partij
                      bij deze voorwaarden), maar Apple en andere Leden van het McDonald’s System zijn op
                      grond van deze voorwaarden wel derden-begunstigden en zij mogen de rechten die
                      McDonald’s uit hoofde van deze voorwaarden jegens jou kan uitoefenen afdwingen voor
                      zover die voorwaarden op hen betrekking hebben; er zijn geen andere derden-begunstigden uit hoofde van deze voorwaarden.
                    </li>
                    <li>Bij beëindiging van deze voorwaarden of van je toestemming voor het gebruik van de onlinediensten, vervallen alle rechten die op grond van deze voorwaarden aan jou zijn verleend; deze voorwaarden blijven echter van toepassing op je eerdere gebruik van de onlinediensten en op alles wat verband houdt met of voortvloeit uit dat gebruik. Bij beëindiging blijven alle rechten van McDonald’s en andere Leden van het McDonald’s System onverminderd bestaan, met inbegrip van alle in deze voorwaarden genoemde intellectuele eigendomsrechten, eigendomsrechten en licenties, evenals alle gebruiksbeperkingen, aansprakelijkheidsbeperkingen en vrijwaringen.
                    </li>
                    <li>Alle bepalingen van deze voorwaarden gelden ook afzonderlijk. Indien een van die
                      bepalingen onrechtmatig, nietig of niet-afdwingbaar is, blijven de overige voorwaarden
                      volledig van kracht.
                    </li>
                    <li>Als McDonald’s er niet bij jou op aandringt je verplichtingen uit hoofde van deze
                      voorwaarden te vervullen, of als McDonald’s haar rechten jegens jou niet afdwingt of het
                      afdwingen daarvan uitstelt, betekent dit niet dat McDonald’s afstand heeft gedaan van haar
                      rechten jegens jou en betekent niet dat je die verplichtingen niet hoeft te vervullen.
                    </li>
                    <li>McDonald’s kan haar rechten en verplichtingen uit hoofde van deze voorwaarden
                      overdragen aan een andere organisatie of entiteit, zonder dat jouw rechten of onze
                      verplichtingen uit hoofde van deze voorwaarden daardoor worden aangetast. Je mag jouw
                      rechten en verplichtingen uit hoofde van deze voorwaarden uitsluitend aan een ander
                      overdragen met schriftelijke toestemming van McDonald’s.
                    </li>
                  </ul>
                </div>
              </AccordionItemBody>
            </AccordionItem>
          </Accordion>
        </div>
    )
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/components/Terms.jsx